import React from 'react'
import ContactContainer from './ContactContainer'

const Contact = () => <ContactContainer data-test="component-tradeIn-contact" />

export default Contact
